import {
    type IAgentRuntime,
    type Memory,
    type Provider,
    type State,
    elizaLogger,
} from "@elizaos/core";
import { TOKEN_ADDRESSES } from "../utils/constants";

const tokensProvider: Provider = {
    name: "tokensProvider",
    description: "Provides available token addresses on Avalanche",
    get: async (_runtime: IAgentRuntime, _message: Memory, _state: State) => {
        elizaLogger.debug("tokensProvider::get");
        const tokens = Object.entries(TOKEN_ADDRESSES)
            .map(([key, value]) => `${key}: ${value}`)
            .join("\n");
        return {
            text: `The available tokens and their addresses are:\n${tokens}`,
            data: TOKEN_ADDRESSES
        };
    },
};

export { tokensProvider };
